<ng-container *ngIf="location">
  <span class="comma" *ngIf="location.streetAddress">{{location.streetAddress}}</span>
  <span class="comma" *ngIf="location.locality">{{location.locality}}</span>
  <span class="comma" *ngIf="location.municipality">{{location.municipality}}</span>
  <span class="comma" *ngIf="location.county">{{location.county}}</span>
</ng-container>
